
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 242.5 239.46"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-cf7","transform":"translate(1.72)"}},[_c('circle',{attrs:{"cx":"119.73","cy":"119.73","r":"116.15","fill":"none"}})])]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"clip-path":"url(#clip-path-cf7)"}},[_c('circle',{attrs:{"cx":"121.45","cy":"119.73","r":"116.15","fill":"#33c6f4"}}),_c('path',{attrs:{"d":"M239.32 167.79c-53.41-24-108.37-91.46-113-94.55s-10.84.77-10.84.77c-3.87-6.19-10.06.77-10.06.77C76.77 123.55.14 170.11.14 170.11s36.8 67.68 121.86 67.68c86.48 0 117.32-70 117.32-70z","transform":"translate(1.72)","fill":"#1b447e"}}),_c('path',{attrs:{"d":"M67.48 116.58s15.48-7 12.38 4.65-15.48 28.64-11.61 29.41 14.75-10.06 17.81-8.52 5.42.78 3.87 6.2-3.1 9.29 0 9.29 5.42-7 9.29-13.94 10.06-3.87 12.38-1.55 9.29 15.49 14.71 13.94 8.51-8.52 6.19-24 1.55-20.12 1.55-20.12 4.64-2.32 13.16 8.51 24 27.09 26.31 26.32-10.83-17.8-7.74-19.35 15.48 2.32 21.68 7.74c0 0 2.12 8.87 2.12.36l-63.27-62.28-10.84.76-10.06.77s-24.77 37.17-37.93 41.81z","transform":"translate(1.72)","fill":"#fff"}}),_c('path',{attrs:{"d":"M241.04 170.11c-53.41-24-108.37-93.78-113-96.87s-10.84.77-10.84.77c-3.87-6.19-10.06.77-10.06.77C78.49 123.55 1.86 170.11 1.86 170.11","fill":"none","stroke":"#221e1f","stroke-miterlimit":"10","stroke-width":"7.16"}})]),_c('circle',{attrs:{"cx":"121.45","cy":"119.73","r":"116.15","fill":"none","stroke":"#221e1f","stroke-miterlimit":"10","stroke-width":"7.16"}})])])])
          )
        }
      }
    